var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        x: "0",
        y: "0",
        viewBox: "0 0 50 50",
        "xml:space": "preserve",
      },
    },
    [
      _c("path", {
        style: "fill: " + _vm.setFillColors.inner,
        attrs: {
          d: "M36.47 41.06H13.54c-.4 0-.73-.33-.73-.73V9.66c0-.4.33-.73.73-.73h16.48c.19 0 .38.08.51.21l6.45 6.45c.14.14.21.32.21.51v24.22c0 .42-.32.74-.72.74zm-22.21-1.45h21.48V16.42l-6.02-6.03H14.26v29.22z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        style: "fill: " + _vm.setFillColors.inner,
        attrs: {
          d: "M36.47 16.85h-6.45c-.4 0-.73-.33-.73-.73V9.66a.726.726 0 0 1 1.24-.51l6.45 6.45a.734.734 0 0 1-.51 1.25zm-5.73-1.46h3.97l-3.97-3.97v3.97zM30.02 36.6c-1.93 0-3.51-1.57-3.51-3.51 0-1.93 1.57-3.51 3.51-3.51 1.93 0 3.51 1.57 3.51 3.51-.01 1.94-1.58 3.51-3.51 3.51zm0-5.55c-1.13 0-2.05.92-2.05 2.05s.92 2.05 2.05 2.05 2.05-.92 2.05-2.05-.92-2.05-2.05-2.05zM32.57 27.77H17.43c-.4 0-.73-.33-.73-.73 0-.4.33-.73.73-.73h15.15c.4 0 .73.33.73.73-.01.41-.33.73-.74.73zM22.74 33.83h-5.31c-.4 0-.73-.33-.73-.73 0-.4.33-.73.73-.73h5.31c.4 0 .73.33.73.73a.74.74 0 0 1-.73.73zM32.57 24.28H17.43c-.4 0-.73-.33-.73-.73 0-.4.33-.73.73-.73h15.15c.4 0 .73.33.73.73-.01.4-.33.73-.74.73zM32.57 20.78H17.43c-.4 0-.73-.33-.73-.73 0-.4.33-.73.73-.73h15.15c.4 0 .73.33.73.73-.01.41-.33.73-.74.73z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        style: "fill: " + _vm.setFillColors.outer,
        attrs: {
          d: "M25 49C11.77 49 1 38.23 1 25S11.77 1 25 1s24 10.77 24 24-10.77 24-24 24zm0-46.55C12.57 2.45 2.45 12.57 2.45 25c0 12.43 10.11 22.55 22.55 22.55S47.55 37.43 47.55 25C47.55 12.57 37.43 2.45 25 2.45z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }